import EvidenceTimeline from '@/components/Table/EvidenceTimeline/EvidenceTimeline';
import { useResolvedAssociationTab } from '@/hooks/useResolvedAssociationTab';
import { XMarkIcon } from '@heroicons/react/16/solid';
import { GoInfo } from 'react-icons/go';

type EvidenceTimelinePanelProps = {
  rowData: any;
  onClose: () => void;
};

export default function EvidenceTimelinePanel({ rowData, onClose }: EvidenceTimelinePanelProps) {
  const resolvedTab = useResolvedAssociationTab();
  const timeline = Array.isArray(rowData?.timeline) ? rowData.timeline : null;
  const publicationsByYear = rowData?.publicationsByYear ?? null;

  const geneLabel =
    resolvedTab === 'VDA'
      ? rowData?.variantStrID || rowData?.geneSymbol || ''
      : rowData?.geneSymbol || '';
  const diseaseLabel = rowData?.diseaseName || '';
  const associationLabel = [geneLabel, diseaseLabel].filter(Boolean).join(' — ');

  return (
    <div className="flex flex-col h-full bg-white overflow-hidden">
      <div className="flex items-center justify-between flex-shrink-0 px-4 py-3 border-b border-gray-200 bg-gray-50">
        <div className="flex items-center gap-2 min-w-0">
          <GoInfo className="w-5 h-5 shrink-0 text-blue" aria-hidden />
          <h2 className="text-sm font-semibold text-gray-900 truncate min-w-0 m-0 leading-tight">
            Evidence timeline
          </h2>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-200 flex-shrink-0"
          aria-label="Close evidence timeline"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>

      {associationLabel && (
        <div className="px-4 py-2 bg-blue-50 border-b border-blue-100">
          <p className="text-xs font-medium text-blue-800 truncate mb-0" title={associationLabel}>
            {associationLabel}
          </p>
        </div>
      )}

      <div className="flex-1 overflow-y-auto p-3 min-h-0" id="evidence-timeline-content">
        {rowData?._evidenceTimelineError ? (
          <p className="text-sm text-red-600 text-center mt-6">Could not load the evidence timeline.</p>
        ) : Array.isArray(timeline) && timeline.length > 0 ? (
          <div className="flex flex-col h-full min-h-0">
            {rowData?._evidenceTimelineLoading ? (
              <p className="text-sm text-gray-500 text-center mb-2">Updating timeline…</p>
            ) : null}
            <EvidenceTimeline timeline={timeline} publicationsByYear={publicationsByYear} rowData={rowData} />
          </div>
        ) : rowData?._evidenceTimelineLoading ? (
          <p className="text-sm text-gray-500 text-center mt-8">Loading timeline…</p>
        ) : (
          <p className="text-sm text-gray-400 text-center mt-6">No evidence timeline available.</p>
        )}
      </div>
    </div>
  );
}
